import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SiVisualstudio,
  SiVisualstudiocode,
  SiInsomnia,
  SiDotnet,
  SiVmware,
  SiUnrealengine,
  SiBlender,
  SiBootstrap,
  SiGithub,
  SiGimp,
  SiUnity,
  SiPrettier
} from "react-icons/si";
import {
  DiNodejs,
  DiNpm,
} from "react-icons/di";

function Toolstack() {
  const icons = [
    { Icon: SiVmware, name: "VMware" },
    { Icon: SiDotnet, name: ".NET" },
    { Icon: SiVisualstudio, name: "Visual Studio" },
    { Icon: SiVisualstudiocode, name: "Visual Studio Code" },
    { Icon: SiInsomnia, name: "Insomnia" },
    { Icon: DiNodejs, name: "Node.js" },
    { Icon: DiNpm, name: "npm" },
    { Icon: SiBootstrap, name: "Bootstrap" },
    { Icon: SiPrettier, name: "Prettier" },
    { Icon: SiGithub, name: "GitHub" },
    { Icon: SiGimp, name: "GIMP" },
    { Icon: SiUnity, name: "Unity" },
    { Icon: SiUnrealengine, name: "Unreal Engine" },
    { Icon: SiBlender, name: "Blender" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {icons.map((iconObj, index) => (
        <Col key={index} xs={4} md={2} className="tech-icons">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-${index}`}>{iconObj.name}</Tooltip>}
          >
            <span>
              <iconObj.Icon />
            </span>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
